import { render, staticRenderFns } from "./LeaderboardRankingsCard.vue?vue&type=template&id=05249bee&scoped=true&"
import script from "./LeaderboardRankingsCard.vue?vue&type=script&lang=js&"
export * from "./LeaderboardRankingsCard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardRankingsCard.vue?vue&type=style&index=0&id=05249bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05249bee",
  null
  
)

export default component.exports